import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $cardLimitStore, $profileFeatureStore } from '@lib/store';
import { useCardFlow } from '@shared/hooks';
import { cn, PaletteUtils } from '@shared/utils';
import { CardStatus, type CardDetailsResponse } from '@shared/api';
import {
  ActivateModal,
  BlockCardModal,
  CardDetailsModal,
  CardSidebarItems,
  EditRecipientsModal,
  ReportModal,
  RequestNewLimitsModal,
  RequestPinModal,
} from '@widgets';
import { Button } from '@shared/widgets';

interface CardSidebarProps {
  card: CardDetailsResponse;
}

export const CardSidebar = (props: CardSidebarProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const cardLimitsStore = useUnit($cardLimitStore.store);

  const [showActivateModal, setShowActivateModal] = useState<boolean>(false);
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [showPinModal, setShowPinModal] = useState<boolean>(false);
  const [showBlockModal, setShowBlockModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [showModalEditRecipients, setShowModalEditRecipients] = useState<boolean>(false);
  const [showLimitsModal, setShowLimitsModal] = useState<boolean>(false);

  const { t } = useTranslation('card');

  const cardFlow = useCardFlow(profileFeatureStore.data?.cardFlows, props.card.cardId);
  return (
    <>
      <div>
        {cardFlow?.activateCard && props.card.status === CardStatus.Inactive && (
          <div className={cn('mb-6 text-center', PaletteUtils.isVcfcPalette && 'max-md:mt-6')}>
            <Button
              className={cn('min-w-48', PaletteUtils.isVcfcPalette && 'max-md:min-w-full')}
              color='primary'
              onClick={() => setShowActivateModal(true)}
            >
              {t('sidebar.buttons.activate')}
            </Button>
          </div>
        )}
        <CardSidebarItems
          card={props.card}
          openBlockModal={setShowBlockModal}
          openEditRecipientsModal={() => setShowModalEditRecipients(true)}
          openLimitsModal={() => setShowLimitsModal(true)}
          openPinModal={() => setShowPinModal(true)}
          openReportModal={() => setShowReportModal(true)}
          openDetailsModal={() => setShowDetailsModal(true)}
          showBlockModal={showBlockModal}
        />
      </div>
      <ActivateModal isOpen={showActivateModal} onClose={() => setShowActivateModal(false)} />
      <CardDetailsModal isOpen={showDetailsModal} onClose={() => setShowDetailsModal(false)} />
      <RequestPinModal isOpen={showPinModal} onClose={() => setShowPinModal(false)} />
      <BlockCardModal isOpen={showBlockModal} onClose={() => setShowBlockModal(false)} />
      <ReportModal isOpen={showReportModal} onClose={() => setShowReportModal(false)} />
      <EditRecipientsModal
        isOpen={showModalEditRecipients}
        onClose={() => setShowModalEditRecipients(false)}
        cardId={props.card.cardId}
        subId={props.card.declinedAuthorizationSubscription?.subscriptionId}
        recipients={props.card.declinedAuthorizationSubscription?.recipientDetails}
      />
      {cardLimitsStore.data && showLimitsModal && <RequestNewLimitsModal isOpen={showLimitsModal} onClose={() => setShowLimitsModal(false)} />}
    </>
  );
};
